module.exports = "/_next/static/media/f04a6d430e5de977926aeed9cf4691dc.png";